import React from 'react';

const FileUploadSection = ({
  title,
  accept,
  files,
  existingFiles,
  handleChange,
  removeFile,
  removeExisting
}) => {
  return (
    <div className="payment-wizard__file-uploads">
      <h5 className="payment-wizard__section-subtitle">{title}</h5>
      {existingFiles.length > 0 && (
        <div className="payment-wizard__existing-files">
          {existingFiles.map((file, index) => (
            <div key={index} className="payment-wizard__file-item">
              <a href={file} target="_blank" rel="noopener noreferrer">{file}</a>
              <button type="button" onClick={() => removeExisting(index)} className="btn btn-sm btn-danger">
                Remove
              </button>
            </div>
          ))}
        </div>
      )}
      {files.map((file, index) => (
        <div key={index} className="payment-wizard__file-item">
          <span>{file.name}</span>
          <button type="button" onClick={() => removeFile(index)} className="btn btn-sm btn-danger">
            Remove
          </button>
        </div>
      ))}
      <input
        type="file"
        accept={accept}
        multiple
        onChange={handleChange}
        className="form-control"
      />
    </div>
  );
};

export default FileUploadSection;

